import { CreditNoteRepository } from "../repositories/CreditNoteRepository";
import {
  CreditNoteDocumentType,
  CreditNoteListStatus,
  CreditNotesResultEntity,
} from "../entities/CreditNoteEntity";

/**
 * Get All Credit Notes Use Case
 * Retrieves credit notes through the unified list endpoint.
 */
export class GetAllCreditNotesUseCase {
  constructor(private repository: CreditNoteRepository) {}

  async execute(params?: {
    limit?: number;
    offset?: number;
    status?: CreditNoteListStatus;
    search?: string;
    date_from?: string;
    date_to?: string;
    sort_by?: "created_at" | "updated_at" | "document_number" | "status";
    sort_order?: "asc" | "desc";
    document_type?: CreditNoteDocumentType;
  }): Promise<CreditNotesResultEntity> {
    if (params?.limit !== undefined && (params.limit < 1 || params.limit > 100)) {
      throw new Error("Limit must be between 1 and 100");
    }

    return await this.repository.fetchCreditNotes(params);
  }
}
